import React from 'react';

import './ModifyHistory.scss';
import CategoryForm, { Content, Label, Row } from '../../../common/CategoryForm';

interface IModifyHistoryProps {
  firstCreateName?: string;
  firstCreateDate?: string;
  lastUpdateName?: string;
  lastUpdateDate?: string;
}
const ModifyHistory = ({ firstCreateName, firstCreateDate, lastUpdateName, lastUpdateDate }: IModifyHistoryProps) => {
  return (
    <CategoryForm className="modify-history-wrap">
      <Row>
        <Label text="최초 생성자" />
        <Content>
          <div className="base-form">{firstCreateName}</div>
        </Content>
        <Label text="생성 일자" />
        <Content>
          <div className="base-form">{firstCreateDate}</div>
        </Content>
      </Row>
      <Row>
        <Label text="마지막 수정자" />
        <Content>
          <div className="base-form">{lastUpdateName}</div>
        </Content>
        <Label text="마지막 수정일" />
        <Content>
          <div className="base-form">{lastUpdateDate}</div>
        </Content>
      </Row>
    </CategoryForm>
  );
};

export default ModifyHistory;
